<template>
  <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1100">
    <button
      v-if="getToasts.length > 0"
      role="button"
      type="button"
      @click="dismissAllToasts"
      class="btn btn-secondary btn-sm"
    >
      {{ $t('network.notification.clearAll', 'Clear All') }}
    </button>
    <Toast
      v-for="(t, i) in getToasts"
      :key="t.id"
      :index="i"
      :toast="t"
      @dismiss="dismissToast"
    ></Toast>
  </div>
</template>

<script>
import Toast from './Toast.vue';
export default {
  components: { Toast },

  computed: {
    getToasts() {
      return this.$store.getters['toast/getToasts'];
    },
  },

  methods: {
    dismissToast(index) {
      this.$store.dispatch('toast/deleteToast', index);
    },
    dismissAllToasts() {
      this.$store.dispatch('toast/deleteAllToasts');
    },
  },
};
</script>
